<mat-card
  [style]="getColorSchemeStyle()"
  [ngClass]="!isAssigned ? 'unassigned' : 'color-scheme'"
>
  <mat-card-header>
    <mat-card-title *ngIf="isAssignment">{{
      status | uppercase
    }}</mat-card-title>
    <mat-card-title
      *ngIf="!isAssignment"
      [matTooltip]="dayTitle + ' ' + pageTitle"
      >{{ dayTitle }} {{ pageTitle | truncateText: 20 }}</mat-card-title
    >
  </mat-card-header>
  <img
    id="card-image"
    mat-card-image
    [routerLink]="isLink ? gradeUnitDaysLink : null"
    [queryParams]="isLink ? queryParams : null"
    [alt]="getAlt()"
    [src]="getImgSrc()"
  />
  <mat-card-content>
    <span
      class="title"
      *ngIf="isAssignment"
      [matTooltip]="dayTitle + ' ' + pageTitle"
    >
      {{ dayTitle }} {{ pageTitle | truncateText: 15 }}
    </span>
    <span
      class="description"
      *ngIf="!isAssignment"
      [matTooltip]="dayDescription"
      >{{ dayDescription }}
    </span>
    <div *ngIf="showDueDate" (click)="prevent($event)">
      <p class="date">{{ dueDateStatus }}</p>
      <ng-container *ngIf="toggleDatePicker; else showDueDateLink">
        <mat-form-field appearance="fill">
          <mat-label>Choose a due date</mat-label>
          <input
            type="text"
            id="dueDate"
            name="dueDate"
            matInput
            (dateChange)="assignDate($event)"
            [matDatepicker]="picker"
            [(ngModel)]="gradeUnitDay.assignmentDueDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </ng-container>
      <ng-template #showDueDateLink>
        <p class="dueDate" (click)="openEdit()">
          <a (click)="assignDate($event)"
            >{{ gradeUnitDay.assignmentDueDate | date: 'EE, MMMM d, yyyy' }}
            <mat-icon *ngIf="getAllowEdit()">edit</mat-icon></a
          >
        </p>
      </ng-template>
    </div>
  </mat-card-content>
  <mat-card-actions *ngIf="actionsVisible()">
    <div>
      <button
        class="action-button"
        mat-raised-button
        color="primary"
        (click)="onAssignClick($event)"
      >
        {{ isAssigned ? 'UPDATE' : 'ASSIGN' }}
      </button>
      <ng-container *ngIf="isAssigned">
        <button
          class="action-button"
          mat-raised-button
          color="primary"
          (click)="openUnassignDialog($event)"
        >
          UNASSIGN
        </button>
      </ng-container>
    </div>
  </mat-card-actions>
  <mat-card-footer *ngIf="isTeacher">
    <p class="progress" *ngIf="status !== 'Unassigned' && !actionsVisible()">
      Class Progress
    </p>
    <mat-progress-bar
      *ngIf="!actionsVisible()"
      mode="determinate"
      value="{{ progressValue }}"
    ></mat-progress-bar>
  </mat-card-footer>
</mat-card>
